<template>
  <div>
    <div class="text-center pt-10 pb-5 Kanit">
      <div>
        <span style="position: relative">
          <v-icon color="primary" size="140">mdi-circle-outline</v-icon>
          <v-icon
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            color="#F41608"
            size="90"
            >mdi-check</v-icon
          >
        </span>
      </div>
      <div class="primary--text" style="font-size: 16px">
        ท่านได้ทำการแลกของรางวัลเรียบร้อยแล้ว
      </div>
      <div class="px-7 pt-5">
        <v-btn
          style="font-size: 22px"
          class="text-capitalize"
          color="primary"
          dark
          block
          @click="next"
          >ดูประวัติการแลก</v-btn
        >
        <v-btn
          @click="$liff.closeWindow()"
          style="font-size: 22px"
          class="text-capitalize mt-2"
          color="grey"
          dark
          block
          >ปิด</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    next() {
      this.$store.state.redirectview = "PointManager";
      this.query.view = "Rewardhistory";
    },
  },
};
</script>

<style lang="scss" scoped>
</style>